import mixins from 'synergycms_core/src/less/mixins';

export default {
  day: {

  },
  selected : {},
  tabTitle:{
    textTransform: 'uppercase',
    width: '100%',
    padding: '10px 0',
    textAlign: 'center',
    '@media (min-width: 801px)': {
      padding: '10px 5px',
      height: '65px',
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      left: '0',
      bottom: '0',
      right: '0',
      height: '0',
      background: 'transparent',
      ...mixins.transition('.3s')
    },
    '& span': {
      font: data => '400 13px ' + data.fontFamily1,
      '@media (min-width: 801px)': {
        textTransform: 'none',
        letterSpacing: '1px',
        fontSize: '16px'
      }
    },
    '& $selected': {
      '&:after': {
        height: '3px',
        background: data => data.mainColor
      },
      '& span': {
        color: data => data.mainColor
      },
    }
  },
  AvailDatepickerCalendar:{
    height:'100%',
    '& > div':{
      height:'100%',
    },
    '@media(min-width:801px)':{
      '& > div':{
        '& > div':{
          boxShadow:'none',
          top:'0!important'
        }
      },
    }
  },
  dayText: {
    display:'block',
    font:data =>'500 15px/15px '+ data.fontFamily1
  },
  priceText:{
    display:'block',
    font:data =>'500 9px/16px '+ data.fontFamily1,
    color:'#767676',
    marginLeft:'2px',
    '@media(min-width:951px)':{
      marginLeft:'3px'
    }
  },
  restrictionText:{
    display:'block',
    marginTop:'2px',
  },
  noDispoDayText:{
    textDecoration:'line-through',
    color:'rgba(187,187,187,.87)',
  },
  dispoDayText:{
    textDecoration:'line-through',
    color:'rgba(187,187,187,.87)',
  },
  dayContainer:{
    minHeight:'33px',
    '& > div':{
      minHeight:'33px'
    }
  },
  restrictionContainer:{
    padding:'10px 30px 10px 15px',
    background:'#F0F7FF',
    font:data =>'300 12px/16px '+ data.fontFamily1,
    textAlign:'center',
    '& $priceText':{
      marginLeft:'0',
      fontSize:'12px'
    },
    '@media(min-width:801px)':{
      padding:'10px 25px 10px 15px'
    }
  },
  priceWithRestriction:{
    '&:before':{
      content:"''",
      position:'absolute',
      left:'0',
      top:'2px',
      width: 0,
      height: 0, 
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderBottom: data=> '7px solid '+data.mainColor,
      transform:'rotate(315deg)'
    }
  },
  hidePrice:{
    '& $dayText':{
      position:'relative',
      paddingBottom:'5px',
      '&:after':{
        content:"''",
        position:'absolute',
        left:'3px',
        bottom:'-5px',
        right: '3px',
        height: '2px', 
        background:data => data.secondColor
      }
    }
  },
  bestPrice:{
    color:data => data.secondColor
  },
  tooltipCalendar:{
    position:'absolute',
    zIndex:900,
    marginTop:'-11px',
    '& $priceText':{
      paddingRight: '10px',
    },
    '& > span':{
      marginTop:'-4.5px',
      fontSize:'9px',
      fontWeight:'300'
    }
  },
  displacedCloseButton:{
    '& > span':{
      top:'50%'
    }
  },
  dateChangeButton: {
    padding:'5px 35px',
    //position:'fixed',
    bottom:'0',
    left:'10px',
    right:'10px',
    height:'auto!important',
    background:'#fff',
    zIndex:5,
    textAlign:'center',
    '@media(min-width:801px)': {
      background:'#fff',
      paddingLeft:'35px',
      position:'static',
      paddingBottom:'10px'
    }
  },
  aclarationDatepickerTextContainer:{
    textAlign:'center',
    background:'#fff',
    '@media(min-width:801px)': {
      textAlign: 'left',
    }
  },
  aclarationDatepickerText:{
    font:data=>'300 12px/14px '+ data.fontFamily1,
    color:'rgba(187,187,187,.87)'
  },
  availDatepickerModal:{
    position:'relative',
    '& $dateChangeButton':{
      bottom:'40px',
      left:'0',
      right:'0',
      '@media(min-width:801px)': {
        bottom:'-40px',
        left:'0',
        right:'auto',
        position:'absolute',
        maxWidth: '440px',
        '&:lang(ar)':{
          right: '0',
          left: 'auto',
        }
      }
    }
  },
  roundedTheme:{
    '&$dateChangeButton':{
      borderRadius: '0 0 25px 25px',
    },
    '&$AvailDatepickerCalendar':{
      background: '#fff',
      borderRadius: '25px',
    }
  },
};